import { render, staticRenderFns } from "./ReviewWorkbenchEntryCard.vue?vue&type=template&id=84024de8&scoped=true"
import script from "./ReviewWorkbenchEntryCard.vue?vue&type=script&lang=js"
export * from "./ReviewWorkbenchEntryCard.vue?vue&type=script&lang=js"
import style0 from "./ReviewWorkbenchEntryCard.vue?vue&type=style&index=0&id=84024de8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84024de8",
  null
  
)

export default component.exports